import React from "react";
import PaginationControl from "./PaginationControl";

const LoginHistoryTable = ({
  isLoading,
  loginHistories,
  currentPage,
  currentPerPage,
  totalPages,
  handlePageChange,
  mapppingColorForBGBadgeRole,
}) => {
  return (
    <div>
      <div className="table-responsive scrollable-container">
        <table className="table table-hover align-middle text-nowrap">
          <thead className="table-light">
            <tr>
              <th>No</th>
              <th>User Info</th>
              <th>Role</th>
              <th>Waktu Login</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="4" className="text-center py-5">
                  <div
                    className="spinner-border text-primary mb-2"
                    role="status"
                  ></div>
                  <div className="text-muted small">Memuat data...</div>
                </td>
              </tr>
            ) : (
              <>
                {loginHistories.length > 0 ? (
                  loginHistories.map((history, idx) => (
                    <tr key={history.id}>
                      <td style={{ width: "50px" }}>
                        {(currentPage - 1) * currentPerPage + idx + 1}
                      </td>
                      <td style={{ minWidth: "200px" }}>
                        <div>{history.user?.name}</div>
                        <small className="text-muted">
                          {history.user?.email}
                        </small>
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            mapppingColorForBGBadgeRole[history.user?.role] ||
                            "bg-secondary"
                          } text-white`}
                        >
                          {history.user?.role}
                        </span>
                      </td>
                      <td>
                        {new Date(history.logged_in_at).toLocaleString(
                          "id-ID",
                          {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4 text-muted">
                      Tidak ada data ditemukan
                    </td>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>

      <PaginationControl
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default LoginHistoryTable;
